import { useApi } from '@/api';
import {
  EntityName,
  IconKpiCard,
  KpiCard,
  Link,
  Page,
  PageSkeleton
} from '@/components';
import {
  CryptoIcon,
  Flex,
  Heading,
  LinkWrapper,
  NetworkIcon
} from '@blockanalitica/ui';
import HistoricTabs from './HistoricTabs';
export default function ArbitrumPage() {
  const [data, error] = useApi({
    url: '/arbitrum/'
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <EntityName symbol1={<NetworkIcon name="arbitrum" size="5" />}>
            <Heading size="1">
              <Flex gap="xs">Arbitrum</Flex>
            </Heading>
          </EntityName>
        }>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <IconKpiCard
            leftIcon={
              <EntityName
                symbol1={<CryptoIcon name={'USDS'} size="3" />}
                symbol2={<CryptoIcon name={'sUSDS'} size="3" />}>
                <></>
              </EntityName>
            }
            title="Total Circulating Assets"
            data={data}
            field="circulating_supply"
            options={{
              currencyValueOptions: { currency: 'USD' },
              linkArrow: false
            }}
          />
        </Flex>

        <HistoricTabs />
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <LinkWrapper
            to="/tokens/arbitrum/0x6491c05a82219b8d1479057361ff1654749b876b"
            // @ts-ignore
            as={Link}
            variant="kpiCardLinkWithBlendMode">
            <KpiCard
              variant="usds"
              title="USDS circulating supply"
              field="usds_circulating_supply"
              data={data}
              options={{
                currency: 'USD',
                linkArrow: true
              }}
            />
          </LinkWrapper>
          <LinkWrapper
            to="/tokens/arbitrum/0xddb46999f8891663a8f2828d25298f70416d7610"
            // @ts-ignore
            as={Link}
            variant="kpiCardLinkWithBlendMode">
            <KpiCard
              variant="susds"
              title="sUSDS circulating supply"
              field="susds_circulating_supply"
              data={data}
              options={{
                currency: 'USD',
                linkArrow: true
              }}
            />
          </LinkWrapper>
        </Flex>
      </Page>
    );
  }
  return <PageSkeleton />;
}
